import {useRouteMatch, Switch, Route} from 'react-router-dom';
import {Economy} from './economy';
import React, {FC} from 'react';

export const EconomyRoute: FC = React.memo(() => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path}>
        <Economy />
      </Route>
    </Switch>
  );
});
